/**
 * <pdp-reviews>: filteren op sterren, sorteren en "meer reviews" voor
 * sections/pdp-reviews.liquid. Alle reviews staan al in de HTML; dit script zet alleen
 * `hidden` en de volgorde. Zonder JS staan de eerste reviews er gewoon.
 *
 * Filters: de chips én de rijen van de sterrenverdeling dragen data-filter (0 = alles).
 * Ze delen één staat, zodat een klik op "4★" in de verdeling ook de chip "4★" aanzet.
 */
class PdpReviews extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';

    this.list = this.querySelector('[data-list]');
    this.cards = [...this.querySelectorAll('.pdp-reviews__card')];
    this.moreButton = this.querySelector('[data-more]');
    this.progressText = this.querySelector('[data-progress-text]');
    this.sortSelect = this.querySelector('[data-sort]');
    this.filterButtons = [...this.querySelectorAll('[data-filter]')];
    this.perPage = Number(this.dataset.perPage) || 6;
    this.template = this.dataset.progress || '';

    this.filter = 0;
    this.visible = this.perPage;

    for (const button of this.filterButtons) {
      button.addEventListener('click', () => {
        const value = Number(button.dataset.filter) || 0;
        // Nog een klik op het actieve filter zet het weer uit.
        this.setFilter(value === this.filter ? 0 : value);
      });
    }

    this.sortSelect?.addEventListener('change', () => {
      this.sort(this.sortSelect.value);
      this.visible = this.perPage;
      this.render();
    });

    this.moreButton?.addEventListener('click', () => {
      this.visible += this.perPage;
      this.render();
    });

    this.render();
  }

  setFilter(value) {
    this.filter = value;
    this.visible = this.perPage;
    for (const button of this.filterButtons) {
      button.setAttribute('aria-pressed', String((Number(button.dataset.filter) || 0) === value));
    }
    this.render();
  }

  sort(mode) {
    const rating = (card) => Number(card.dataset.rating) || 0;
    const date = (card) => card.dataset.date || '';
    const index = (card) => Number(card.dataset.index) || 0;

    const compare = {
      relevant: (a, b) => index(a) - index(b),
      newest: (a, b) => date(b).localeCompare(date(a)) || index(a) - index(b),
      highest: (a, b) => rating(b) - rating(a) || index(a) - index(b),
      lowest: (a, b) => rating(a) - rating(b) || index(a) - index(b),
    }[mode];
    if (!compare || !this.list) return;

    this.cards.sort(compare);
    this.list.append(...this.cards);
  }

  render() {
    const matches = this.cards.filter((card) => !this.filter || Number(card.dataset.rating) === this.filter);
    const shown = Math.min(this.visible, matches.length);

    let count = 0;
    for (const card of this.cards) {
      const match = matches.includes(card);
      card.hidden = !match || count >= shown;
      if (match) count += 1;
    }

    if (this.moreButton) this.moreButton.hidden = shown >= matches.length;
    if (this.progressText && this.template) {
      this.progressText.textContent = this.template
        .replace('%%SHOWN%%', String(shown))
        .replace('%%TOTAL%%', String(matches.length));
    }
  }
}

if (!customElements.get('pdp-reviews')) customElements.define('pdp-reviews', PdpReviews);
